import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';

import { RegistrationModel } from '../../models/registration';
import { PublicConstants } from '../../public.constants';
import { PublicService } from '../../services/public.service';

// Declare grecaptcha global variable
declare const grecaptcha: any;

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss'],
    standalone: false
})
export class RegisterComponent implements OnInit {

  @Input() input;
  emailEditDisabled = false;
  regFor = PublicConstants.REG_FOR;
  registrationData: RegistrationModel;
  regFormGroup: UntypedFormGroup;
  appBusy = false;
  gCaptchaEnabled: boolean;
  gCaptchaResponse;
  siteKey;
  constructor(private _formBuilder: UntypedFormBuilder, private _service: PublicService) { }

  ngOnInit() {
    this._service.getUIconfig().toPromise()
      .then(resp => {
        this.siteKey = resp.googleCaptchasiteKey;
        this.gCaptchaEnabled = resp.googleCaptchaEnabled;
      })
      .catch(err => this._service.openSnackBar(err.message)
      );
    this.setFormControls();
  }

  setFormControls() {
    this.registrationData = new RegistrationModel();
    this.regFormGroup = new UntypedFormGroup({
      email: new UntypedFormControl(
        {
          value: (this.input && this.input.email) ? this.input.email : null,
          disabled: (this.input && this.input.email)
        },
        [
          Validators.required,
          Validators.maxLength(PublicConstants.NAME_MAX_LENGTH),
          Validators.pattern(PublicConstants.EMAIL_REGEX)
        ]
      ),
      password: new UntypedFormControl(null, [
        Validators.required,
        this.noWhitespaceValidator,
        Validators.minLength(PublicConstants.PW_MIN_LENGTH)
        // Validators.pattern(PublicConstants.TEXT_REGEX)
      ]),
      contactNumber: new UntypedFormControl(null,
        [
          Validators.required,
          Validators.pattern(PublicConstants.MOBILE_REGEX)
        ]
      )
    });
    if (this.regFor === 'Supplier') {

      if (this.regFormGroup.controls.firstName) {
        this.regFormGroup.removeControl('firstName');
      }
      if (this.regFormGroup.controls.lastName) {
        this.regFormGroup.removeControl('lastName');
      }
      if (!this.regFormGroup.controls.orgName) {
        this.regFormGroup.addControl('orgName',
          new UntypedFormControl((this.input && this.input.name) ? this.input.name : null,
            [
              Validators.required,
              this.noWhitespaceValidator,
              // Validators.maxLength(PublicConstants.SUPP_NAME_MAX_LENGTH),
              Validators.pattern(PublicConstants.TEXT_REGEX)
            ]
          )
        );
      }
    } else {
      if (this.regFormGroup.controls.orgName) {
        this.regFormGroup.removeControl('orgName');
      }
      if (!this.regFormGroup.controls.firstName) {
        this.regFormGroup.addControl('firstName',
          new UntypedFormControl(null,
            [
              Validators.required,
              this.noWhitespaceValidator,
              // Validators.maxLength(PublicConstants.SUPP_NAME_MAX_LENGTH),
              Validators.pattern(PublicConstants.TEXT_REGEX)
            ]
          )
        );
      }
      if (!this.regFormGroup.controls.lastName) {
        this.regFormGroup.addControl('lastName',
          new UntypedFormControl(null,
            [
              Validators.required,
              this.noWhitespaceValidator,
              // Validators.maxLength(PublicConstants.SUPP_NAME_MAX_LENGTH),
              Validators.pattern(PublicConstants.TEXT_REGEX)
            ]
          )
        );
      }
    }
  }

  resolved(captchaResponse: string) {
    this.gCaptchaResponse = captchaResponse;
  }

  register() {
    if (this.regFormGroup.valid) {
      if (this.gCaptchaEnabled && !this.gCaptchaResponse) {
        this.appBusy = false;
        this._service.openSnackBar('Captcha required');
        return;
      }
      this.appBusy = true;
      let data = {
        userEmail: this.regFormGroup.controls.email.value,
        userMobile: this.regFormGroup.controls.contactNumber.value,
        userPassword: this.regFormGroup.controls.password.value
      };
      if (this.gCaptchaEnabled) {
        data['captchaResponse'] = this.gCaptchaResponse;
      }
      if (this.regFor === 'Supplier') {
        data['supplierName'] = this.regFormGroup.controls.orgName.value;
        if (this.input && this.input.email) {
          data['supplierEmail'] = this.input.email;
          data['referralCode'] = this.input.referralCode;
        } else {
          data['supplierEmail'] = this.regFormGroup.controls.email.value;
        }
      } else {
        data['firstName'] = this.regFormGroup.controls.firstName.value;
        data['lastName'] = this.regFormGroup.controls.lastName.value;
      }
      this._service.register(data, this.regFor).toPromise()
        .then(response => {
          if (this.gCaptchaEnabled) {
            grecaptcha.reset();
            this.gCaptchaResponse = null;
          }
          if (response && response.errorMessage) {
            this._service.openSnackBar(response.errorMessage);
          } else if (!response) {
            this._service.openSnackBar('Some error occured while registering.');
          } else {
            this._service.openSnackBar('Successfully registered. Please login to the Supplier portal to continue');
            data = null;
            this.setFormControls();
            this._service.goToLogin();
          }
          this.appBusy = false;
        })
        .catch(error => {
          if (this.gCaptchaEnabled) {
            grecaptcha.reset();
            this.gCaptchaResponse = null;
          }
          this._service.openSnackBar(error.error ? error.error.message : error.message);
          this.appBusy = false;
        });

    } else {
      this.validateAllFormFields(this.regFormGroup);
      this.appBusy = false;
    }
  }

  private noWhitespaceValidator(control: UntypedFormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'required': true };
  }

  validateAllFormFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof UntypedFormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof UntypedFormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
}

